import { ReservationsAPI } from "@/api/reservationsAPI";
import {
  GET_RESERVATIONS_DISTRIBUTION_BY_CHANNEL_SUCCESS,
  GET_RESERVATIONS_DISTRIBUTION_BY_CHANNEL_ERROR,
  GET_RESERVATIONS_DISTRIBUTION_BY_CHANNEL_REQUEST,
} from "@/redux/actions";
import { mapDataForRevenueDistributionByChannel } from "@/utils/constants/mapDataForRevenueDistributionByChannel";
import { call, put, takeLatest } from "redux-saga/effects";

export function* workerReservationDistributionByChannel(action: {
  type: string;
  payload: string[];
}): Generator<any> {
  try {
    const response: any = yield call(
      ReservationsAPI.getReservationsDistributionsByChannel,
      action.payload
    );
    yield put({
      type: GET_RESERVATIONS_DISTRIBUTION_BY_CHANNEL_SUCCESS,
      payload: mapDataForRevenueDistributionByChannel(response?.[0]),
    });
  } catch (error) {
    yield put({
      type: GET_RESERVATIONS_DISTRIBUTION_BY_CHANNEL_ERROR,
      payload: error,
    });
  }
}

export function* watcherReservationDistributionByChannel() {
  yield takeLatest(
    GET_RESERVATIONS_DISTRIBUTION_BY_CHANNEL_REQUEST,
    workerReservationDistributionByChannel
  );
}
